import {
  REQUEST_OTP_VERIFICATION,
  RESET_MFA_STATE,
  SEND_OTP,
  SEND_OTP_SUCCESS,
  VERIFY_OTP,
  VERIFY_OTP_SUCCESS
} from "../reducers/mfaReducer";
import Notify from "./notifyActions";
import { getActiveLanguage } from "react-localize-redux";

export const SEND_OTP_SUCCESSFUL_TOAST = 'success_sending_otp'
export const SEND_OTP_FAILURE_TOAST = 'error_sending_otp'

export const VERIFY_OTP_SUCCESSFUL_TOAST = 'success_verifying_otp'
export const VERIFY_OTP_FAILURE_TOAST = 'error_verifying_otp'

export const sendOtp = (data) => {
  return (dispatch, getState) => {

    const state = getState();
    const {mfaEmailAddress, mfaContactNumber} = state.mfaReducer;
    const activeLanguage = state.localeReducer
      ? getActiveLanguage(state.localeReducer)
      : null;
    const selectedLanguage = (activeLanguage && (activeLanguage.code || activeLanguage)) ||
      (state.languageReducer && state.languageReducer.selectedLanguage) ||
      'en-GB';

    return new Promise((resolve, reject) => {
      dispatch({
        type: SEND_OTP,
        payload: {
          request: {
            mode: 'no-cors',
            url: 'otp/send',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            data: {
              ...data,
              emailAddress: mfaEmailAddress,
              contactNumber: mfaContactNumber,
              language: selectedLanguage
            }
          }

        }
      }).then(response => {
        if (response.type === SEND_OTP_SUCCESS) {
          // dispatch(Notify.success(SEND_OTP_SUCCESSFUL_TOAST));
          resolve();
        } else {
          dispatch(Notify.error(SEND_OTP_FAILURE_TOAST))
          reject(new Error('Unable to send OTP.'))
        }
      }).catch(error => {
        dispatch(Notify.error(SEND_OTP_FAILURE_TOAST))
        reject(error);
      });
    });
  };
};


export const verifyOtp = (data) => {
  return (dispatch, getState) => {
    const state = getState();
    const {mfaEmailAddress} = state.mfaReducer;

    return dispatch({
      type: VERIFY_OTP,
      payload: {
        request: {
          mode: 'no-cors',
          url: 'otp/verify',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            ...data,
            emailAddress: mfaEmailAddress,
          }
        },
        options: {
          // OTP mismatches are expected validation failures. Reject so every caller
          // can reliably clear its pending state instead of waiting on a FAIL action.
          returnRejectedPromiseOnError: true
        }
      }
    }).then(response => {
      if (response.type === VERIFY_OTP_SUCCESS) {
        return response;
      }

      throw new Error('Unable to verify OTP.');
    }).catch(error => {
      dispatch(Notify.error(VERIFY_OTP_FAILURE_TOAST));
      return Promise.reject(error);
    });
  };
};

// export const sendOtp = (data) => {
//     return (dispatch, getState) => {
//
//         const state = getState();
//         const {mfaUsername} = state.mfaReducer;
//         const {selectedLanguage} = state.languageReducer;
//
//         dispatch({
//             type: SEND_OTP,
//             payload: {
//                 request: {
//                     mode: 'no-cors',
//                     url: 'otp/send',
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     data: {
//                         ...data,
//                         username: mfaUsername,
//                         language: selectedLanguage
//                     }
//                 }
//
//             }
//         })
//     };
// }

// export const verifyOtp = (data) => {
//     return (dispatch, getState) => {
//
//         const state = getState();
//         const {mfaUsername} = state.mfaReducer;
//
//         dispatch({
//             type: VERIFY_OTP,
//             payload: {
//                 request: {
//                     mode: 'no-cors',
//                     url: 'otp/verify',
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     data: {
//                         ...data,
//                         username: mfaUsername
//                     }
//                 }
//
//             }
//         })
//     };
// }


export const resetMfaState = () => ({
  type: RESET_MFA_STATE,
});


export const requestOtpVerification = (data) => ({
  type: REQUEST_OTP_VERIFICATION,
  payload: {
    data
  }
});
